<template>
  <div class="page-index" v-wechat-title="channelConfig.siteName?channelConfig.siteName:''">
    <template v-if="!loading">
      <page-title
        :fixed="false"
        :propTitle="channelConfig.siteName"
        :propLogo="channelConfig.logoUrl"
      ></page-title>

      <!-- 2021-525倒计时 -->
      <count-down
        v-if="isShowBuoy525"
        :endTime="expireTime525"
        style="position: relative; z-index:9;"
        :class="{'count-down-fixed': countDownFixed}"
      ></count-down>

      <!--Banner-->
      <index-banner :swiperData="banner" class="indexBanner" @swiperClick="bannerClickHandler"></index-banner>
      <div class="yxl-consult-banner" v-if="CHANNEL_CHANNELTYPE&&hideBannerAndConsult" @click="toYXLConsultPage">
        <!-- <i class="yxl-consult-icon"></i> -->
        <img src="../../assets/index/yxl_half_consult_banner.gif" alt="">
      </div>
      <!-- 首页导航 -->
      <showindexNav v-if="CHANNEL_INTERNALCHANNEL&&!CHANNEL_NOT_LOGIN" @viewMoreSort="_viewMoreSort"></showindexNav>
      <!-- 匹配测评入口 -->
      <matchingEntrance v-if="matchEntranceData.showStatus" :entranceData="matchEntranceData"></matchingEntrance>
      <!-- 每日趣测 -->
      <interestSwiper
        v-else-if="CHANNEL_INTERNALCHANNEL&&funTest"
        :funTest="funTest"
        @testClick="interestClickHandler"
        @moreFunTest="_viewMoreSort"
      ></interestSwiper>
      <!--热卖爆款-->
      <recomend-list :indexList="hotList" :type="'hot'" @testClick="testClickHandler"></recomend-list>
      <!--专业测评-->
      <proSwiper
        v-if="proList.length>0&&!CHANNEL_NOT_LOGIN"
        :indexList="proList"
        :type="'hot'"
        @testClick="testClickHandler"
        @viewMoreSort="_viewMoreSort"
      ></proSwiper>
      <!--新品首发-->
      <newSwiper :indexList="newList" :type="'new'" @testClick="testClickHandler"></newSwiper>
      <!--<type-list :typeList="typeList" :fromRoute="fromRoute"></type-list>-->
      <!--精选测评-->
      <testOfChoice :propTestItems="choiceTest" @testClick="testClickHandler"></testOfChoice>
      <!--全部测评，去分类页-->
      <toSort v-if="!isHpnk" ref="toSortLink" @viewMoreSort="_viewMoreSort"></toSort>
      <!-- 壹心理标识 -->
      <yxlCopyright :showTip="isHwrl"></yxlCopyright>
      <!--回到顶部-->
      <go2top :propShow="go2topShow"></go2top>
      <!-- 特定广告位 -->
      <yxyBox @closeYxybox="_closeYxybox()" :showProps="showYxyBox"></yxyBox>

    </template>
    <template v-if="loading">
      <!-- 骨架图 -->
      <skeleton-index></skeleton-index>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import APIS from "../../apis.js";
import { mapState, mapActions } from "vuex";
import { mapMutations } from "vuex";

import pageMixin from "@/mixins/pageMixin";
import pageTitle from "@/components/common/pageTitle.vue";
import indexBanner from "@/components/show/index/bannerSwiper.vue";
import recomendList from "@/components/show/index/testSwiper.vue";
import testOfChoice from "@/components/show/index/testsOfChoice.vue";
import footerNav from "@/components/show/footerNav.vue";
import toSort from "@/components/show/toSort.vue";
import go2top from "@/components/common/gotoTop.vue";
import yxlCopyright from "@/components/common/yxlCopyright.vue";
import skeletonIndex from "./skeleton/showIndex-skeleton.vue";
import couponLogo from "@/components/show/couponLogo.vue";
import yxyBox from "@/components/show/yxyBox.vue";
import { getCookie } from "@/frontend-lib/tools/cookies";
import interestSwiper from "@/components/show/index/interestSwiper.vue";
import showindexNav from "@/components/show/index/showindexNav.vue";
import proSwiper from "@/components/show/index/proSwiper.vue";
import newSwiper from "@/components/show/index/newSwiper.vue";

import countDown from './activity/2021525/count-down';
import matchingEntrance from '@/pages/matching/components/matchingEntrance'

export default {
  name: "pageIndex",
  components: {
    pageTitle: pageTitle,
    indexBanner: indexBanner,
    recomendList: recomendList,
    testOfChoice: testOfChoice,
    footerNav: footerNav,
    toSort: toSort,
    go2top,
    yxlCopyright,
    skeletonIndex,
    couponLogo,
    yxyBox,
    interestSwiper,
    showindexNav,
    proSwiper,
    newSwiper,
    countDown,
    matchingEntrance
  },
  mixins: [pageMixin],
  data() {
    return {
      OKAPI: 0,
      userStayTime: 0,
      banner: [],
      bannerLocation: 1, // 首页 banner 位置
      hotList: [],
      newList: [],
      choiceTest: [],
      proList: [],
      go2topShow: false,
      loading: false,
      allowGlobalAd: true,
      funTest: "",
      couponDialogCallback: "",
      isShowBuoy525: false,
      expireTime525: 0,
      countDownFixed: false,
      matchEntranceData: {}
    };
  },
  computed: {
    ...mapState(["show"]),
    wxShareConfig() {
      const that = this;
      return {
        title: this.CHANNEL_INTERNALCHANNEL?this.INTERNALCHANNEL_SHARE.title:that.channelConfig.siteName,
        link:
          location.origin +
          location.pathname +
          "?channelId=" +
          that.channelId +
          "#" +
          that.$route.path,
        imgUrl: this.CHANNEL_INTERNALCHANNEL?this.INTERNALCHANNEL_SHARE.imgUrl:that.channelConfig.logoUrl
          ? that.channelConfig.logoUrl
          : "http://static.xinli001.com/static-ceping-wz/static/images/logo-brain.png",
        desc: this.CHANNEL_INTERNALCHANNEL?this.INTERNALCHANNEL_SHARE.desc:"专业、有趣、好玩的心理测评，用心理学探索未知的自己。",
        success: function() {
          // 埋点
          window.TRACKER.sharePage("首页");
        },
        cancel: function() {}
      };
    },
    showYxyBox() {
      if (this.yxyid) {
        return true;
      }
      return false;
    },
  },
  beforeRouteEnter(to, from, next) {
    next(function(vm) {
      vm.$data.fromRoute = from;
      vm.$data.debug = !!(to.query.debug * 1);
    });
  },
  created() {
    const that = this;
    that.userStayTime = new Date();
    that.pullHomePageBanner({
      params: {
        channelId: that.channelId,
        bannerLocation: that.bannerLocation
      },
      callback: DATA => {
        that.banner = DATA;
        that.OKAPI++;
      }
    });

    // 最热
    that.pullHotScales({
      params: {
        channelId: that.channelId
      },
      callback: DATA => {
        that.hotList = DATA.scales;
        that.OKAPI++;
        // if (DATA.popTimeLimitCoupon) {
        //     that.couponDialogCallback = DATA.backUrl;
        // }
        // 免登陆不用请求接口
        if (!that.CHANNEL_NOT_LOGIN) {
          // 展示位置：展示位置: 1 首页弹框 2详情页弹框 3 个人中心弹框 4报告页贴片 5 趣味测试结果页弹框 6其他
          this.getCoupon(1);
          //双十二活动弹窗
          this.getVipPopWindow(1);
        }

      }
    });
    // 最新
    that.pullNewScales({
      params: {
        channelId: that.channelId
      },
      callback: DATA => {
        DATA.scales.map((item, index) => {
          if (index < 6) {
            that.newList.push(item);
          }
        });
        that.OKAPI++;
      }
    });
    // 精选测评
    that.pullChoiceScales({
      params: {
        channelId: that.channelId
      },
      callback: DATA => {
        that.choiceTest = DATA.scales;
        that.OKAPI++;
      }
    });
    // 免登陆不用请求数据
    if (!that.CHANNEL_NOT_LOGIN) {
      // 关闭趣味测试
      //每日一测
      that
        .getDailyFunTest({
          params: {}
        })
        .then(res => {
          if (res.code == 1) {
            that.funTest = res.data;
          }
        });
      //专业测评
      that
        .getProfessionalScales({
          params: {
            channelId: that.channelId,
            category: "",
            sortType: 2,
            page: 1,
            pageSize: 2,
            isHome:1,
          }
        })
        .then(res => {
          if (res.code == 1) {
            that.proList = res.data.scales;
          }
        });

      // 创新匹配测评
      this.getMatchEntrance()
    }
  },
  mounted() {
    const that = this;
    that.loading = true;
    this.$nextTick(() => {
      document.addEventListener("scroll", that.setShowToSort);
    })
    that.showPromotion();
    if (that.$route.query.delPdf) {
      that.setTOASTTEXT({ str: "正在制作中稍后请留意邮箱", status: "success" });
    }
    const dialogStore = `oneDayfristdialogStore${new Date().getDate()}`
    if (dialogStore != localStorage.getItem('dialogStore',dialogStore) && this._setshowProps) {
      this.setShowPopWindowStatus(true)
    }

    // 首页加载弹窗浮标数据
    this.initAdCoupon('showIndex')

    if (this.channelConfig.channelType && this.is2021525) {
      this.getActivity525Countdown()
    }

    // 微站-测评大厅访问 神策埋点
    this.$wechatTrackPageView('weizhan_cepinghome_view', {
      tracing_mark:  this.$route.query.sourceName
    })
  },
  updated() {
  },
  beforeDestroy() {
    const that = this;
    document.removeEventListener("scroll", that.setShowToSort);
    // this.setLOADINGTEXT('');
    that.loading = false;
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  watch: {
    OKAPI: function(newVal, oldVal) {
      const that = this;
      if (newVal == 4) {
        if (that.$route.query.noAnchor != 1) {
          that.$nextTick(() => {
            if (that.show.INDEXSCROLLTOP != "") {
              document.body.scrollTop = that.show.INDEXSCROLLTOP;
            }
          });
        }
        that.loading = false;
      }
    },
    IS_WECHAT_CHANNELTYPE() {
      if (this.IS_WECHAT_CHANNELTYPE) {
        this.initAdCoupon('showIndex')
      }
    },
    channelConfig (nv) {
      if (nv.channelType && this.is2021525) {
        this.getActivity525Countdown()
      }
    },
    userInfo(userInfo) {
      if (userInfo.userKey) {
        this.getMatchEntrance()
      }
    }
  },
  methods: {
    ...mapMutations(["setINDEXSCROLLTOP"]),
    ...mapActions([
      "pullHomePageBanner",
      "pullHotScales",
      "pullNewScales",
      "pullChoiceScales",
      "getDailyFunTest",
      "getProfessionalScales",
      "receiveCoupon"
    ]),
    ...mapMutations([
      "setGlobalAdConfirm",
      "setGlobalAdCancel",
      "setGlobalAdPeriod",
      "setGlobalAdShow",
      "setShowPopWindowStatus"
    ]),

    // 获取2021-525活动倒计时
    getActivity525Countdown() {
      this.$http.get(APIS.activity525Countdown).then(res => {
        const { data, code } = res.data
        if (code === '1') {
          this.expireTime525 = data.expireTime
          this.isShowBuoy525 = data.is_show
        }
      })
    },

    getMatchEntrance() {
      if (!this.userInfo.userKey) return
      this.$http.get(APIS.matchEntrance, {
        params: {
          channelId: this.channelId,
          userKey: this.userInfo.userKey
        }
      }).then(res => {
        this.matchEntranceData = res.data.data || {}
      })
    },

    _inPromotion() {
      this.allowGlobalAd = true;
      this.showPromotion();
    },
    bannerClickHandler(item, index) {
      const that = this;
      let url = `${item.redirectUrl}&enterFrom=banner`
      if (that.woNiuSourceName) {
        url += `&unique=${that.woNiuSourceName}`
      }
      window.location.href = url;
      // 埋点
      window.TRACKER.indexBannerClick(index, item.name);
      // 微站-测评大厅-banner图点击 神策埋点
      this.$wechatTrackEvent('weizhan_cepinghome_bannerclick', {
        item_location: index + 1,
        item_id: item.scalePoolId,  // 暂时处理测试id,后续要兼容其他id
        item_name: item.name,
      });
    },
    testClickHandler(testObj, type) {
      const that = this;
      that.setINDEXSCROLLTOP(document.body.scrollTop);

      window.TRACKER.indexTestSwiper(testObj.name, type);

      if (testObj.h5Url) {
        let url = testObj.h5Url
        if (that.woNiuSourceName) {
          url += `&unique=${that.woNiuSourceName}`
        }
        location.href = url;
      } else {
        that.$router.push({
          name: "testDetail",
          path: "/detail",
          params: {
            testId: testObj.scalePoolId
          },
          query: {
            channelId: that.channelId,
            yxyid: that.yxyid,
            unique: that.woNiuSourceName,
            sourceName: that.$route.query.sourceName
          }
        });
      }
    },
    interestClickHandler(testObj) {
      console.log("进入趣味测试");
      let colorType = parseInt(new Date().getDay());
      this.$stat.send({
        name: "点击首页每日趣测",
        properties: { 渠道名称: this.CHANNELNAME, 测试名称: testObj.name }
      });
      this.$router.push({
        path: `./ceshi/${testObj.id}`,
        query: {
          channelId: this.channelId,
          colorType: colorType,
          sortType: 2
        }
      });
    },
    setShowToSort() {
      // 控制是否显示回到顶部
      if(!this.$refs.toSortLink || !this.$refs.toSortLink.$el){
        return
      }
      const offset = this.$refs.toSortLink.$el.offsetTop;
      const offsetHeight =
        document.body.offsetHeight +
        document.body.scrollTop +
        this.$refs.toSortLink.$el.offsetHeight / 2;
      if (offsetHeight > offset) {
        this.go2topShow = true;
      } else {
        this.go2topShow = false;
      }

      if (this.is2021525) {
        const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
        this.countDownFixed = scrollTop > 200
      }
    },
    _viewMoreSort(type) {
      const that = this;
      if (type == "每日一测") {
        this.$stat.send({
          name: "点击首页每日趣测-更多",
          properties: { 渠道名称: this.CHANNELNAME }
        });
      }
      that.$router.push({
        name: "sorts",
        path: "/sorts",
        query: {
          channelId: that.channelId,
          sort: type ? type : ""
        }
      });
    },
    showPromotion() {
      const that = this;
      if (that.channelId == 1166) {
        return;
      }
      if (!that.userInfo.userKey) {
        return;
      }
    },
    _closeYxybox() {
      window.location.href = `http://168renwu.com/Api/Jump/index?yxyid=${
        this.yxyid
      }`;
    },
    toYXLConsultPage() {
      this.$wechatTrackEvent('weizhan_cepinghome_consultingbanner');
      location.href = 'https://m.xinli001.com/consult/special-price?_source_page_=5ZKo6K-i5Li76aG1VjU&channel_flag=ctdl_yxljxwz_banner'
    }
  }
};
</script>

<style lang="scss">
@import "../../scss/function";

.page-index {
  // padding: 0 topx(30rem);
  z-index: 0;
  margin: 0;
  position: relative;
  width: topx(750rem);
  box-sizing: border-box;
  background: #f6f6f6;
}

.count-down-fixed {
  position: fixed !important;
}
.yxl-consult-banner {
  position: relative;
  width: topx(670rem);
  height: topx(175rem);
  margin: topx(20rem) auto topx(30rem);
  border-radius: topx(10rem);
  overflow: hidden;
  box-shadow: 0 0 topx(10rem) 0 rgba(76, 75, 88, 0.05);
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
  .yxl-consult-icon {
    position: absolute;
    top: topx(30rem);
    left: topx(240rem);
    display: block;
    width: topx(35rem);
    height: topx(35rem);
    background: url('../../assets/index/yxl-banner-arrow.png') no-repeat center center;
    background-size: 100% 100%;

    animation-delay: 0s;
    animation-name: shock;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-direction: normal;
    animation-timing-function: linear;
  }

  @keyframes shock {
	    0% {
	        transform: scale(0.9);
	    }
	    100% {
	        transform: scale(1.1);
	    }
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/show/showIndex.vue